import { render, staticRenderFns } from "./iocnCom.vue?vue&type=template&id=1f6a4b87&"
import script from "./iocnCom.vue?vue&type=script&lang=js&"
export * from "./iocnCom.vue?vue&type=script&lang=js&"
import style0 from "./iocnCom.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports